<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><span>Contents</span></h1>
<p class="toc-chapter1" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-chapter1"><span href="#/dedication" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-chapter1" id="toc-preface001"><a href="#/preface001">Preface</a></p>
<p class="toc-chapter1" id="toc-preface002"><a href="#/preface002">Introduction: Mother McCloud</a></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">1.</a>  <a href="#/chapter001">The Fountain of Youth</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">2.</a>  <a href="#/chapter002">Who Gets to Drink?</a></p>
<p class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">3.</span>  <span href="#/chapter003" title="Link target outside of Sample">Is It Safe to Drink the Water?</span></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">4.</span>  <span href="#/chapter004" title="Link target outside of Sample">Death in Small Doses</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">5.</span>  <span href="#/chapter005" title="Link target outside of Sample">Flint</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">6.</span>  <span href="#/chapter006" title="Link target outside of Sample">Blue Terror</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">7.</span>  <span href="#/chapter007" title="Link target outside of Sample">Bigger Than Soft Drinks</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">8.</span>  <span href="#/chapter008" title="Link target outside of Sample">Need Versus Greed</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">9.</span>  <span href="#/chapter009" title="Link target outside of Sample">Finding Water for the Twenty-first Century</span></p>
<p class="toc-chapter1" id="toc-appendix001"><span href="#/appendix001" title="Link target outside of Sample">Afterword: A Glass Half Empty/A Glass Half Full</span></p>
<p class="toc-chapter1" id="toc-endnotes"><span href="#/endnotes" title="Link target outside of Sample">Notes</span></p>
<p class="toc-chapter1" id="toc-index001"><span href="#/index001" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a9dd5a50